// Class: motion.IComponentPath

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../hxClasses_stub").default;

// Constructor

var IComponentPath = function() {}

// Meta

IComponentPath.__name__ = ["motion","IComponentPath"];
IComponentPath.__isInterface__ = true;
IComponentPath.prototype = {
	
};
IComponentPath.prototype.__class__ = IComponentPath.prototype.constructor = $hxClasses["motion.IComponentPath"] = IComponentPath;

// Init



// Statics




// Export

exports.default = IComponentPath;